import { render, staticRenderFns } from "./DeferredDeliveryPreview.vue?vue&type=template&id=558393d5"
import script from "./DeferredDeliveryPreview.vue?vue&type=script&lang=js"
export * from "./DeferredDeliveryPreview.vue?vue&type=script&lang=js"
import style0 from "./DeferredDeliveryPreview.vue?vue&type=style&index=0&id=558393d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports